import React from 'react'
import Config from 'Config'
import axios from 'axios'
import UniqID from 'uniqid'

class Partner extends React.Component {

   constructor() {
      super()
      this.state = {
         data: {
            content: {},
            items: [],
         },
      }
   }

   componentDidMount() {
      this.getData();
   }

   getData() {

      axios.get(Config().endpoints.api + "/partner")
         .then(response => {
            if (response.data) {
               this.setState({
                  data: response.data
               });
            }
         })
         .catch((error) => {})
   }

   render() {

      var partnerList = this.state.data.items.map((item) =>
         <li key={UniqID().toString()}>
            <a href={item.url} target="_blank">
               <img src={item.image} alt={item.title}></img>
            </a>
         </li>
      );

      return (<div>
         <div className="content-container">
            <div className="content-section small-bottom-spacing">
               <h1 className="centered">{this.state.data.content.title}</h1>
               <div className="headline-subtext centered">{this.state.data.content.subtitle}</div>
            </div>
         </div>
         <div className="content-container grey addition section-bottom">
            <div className="content-section full fluid no-spacing">
               <div id="partner-content">
                  <ul>
                     {partnerList}
                  </ul>
               </div>
            </div>
         </div>
      </div>);
   }
}

export default Partner



// WEBPACK FOOTER //
// ./src/components/Partner/index.js